var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('r-form',_vm._b({ref:"form",attrs:{"no-buttons":""},model:{value:(_vm.formData),callback:function ($$v) {_vm.formData=$$v},expression:"formData"}},'r-form',_vm.formProps,false))}
var staticRenderFns = []

export { render, staticRenderFns }